import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonElementComponent } from './button-element.component';
import { ButtonsComponent } from './buttons.component';

const DECLARATIONS = [
    ButtonsComponent,
    ButtonElementComponent,
];

const EXPORTS = [
    ButtonsComponent,
    ButtonElementComponent,
];

/**
 * PRIVATE!
 *
 * Use {@link FormsModule}.
 */
@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: DECLARATIONS,
    exports: EXPORTS
})
export class FormButtonModule {
}
